import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

export const AddYourVoiceBanner: React.FC = () => {
	return (
		<Alert
			data-qa="supporter-voice-text-banner-success"
			variant="success"
			// FIXME: Not using figma's text since OneSky is currently down and we can't add new strings
			heading={<Translate value="corgi.petition_actions.supporter_voice_text.after_submit.message" />}
			type="page"
		>
			{null}
		</Alert>
	);
};
